import CSlider from './CSlider';
import CSliderThumb from './SliderThumb';

export { CSliderThumb };
export default CSlider;
